import { Controller } from '@hotwired/stimulus';

//global prices variables
let price;
let btwPrice;
let priceInclBTW;
let btwAmount;

export default class extends Controller {
	static targets = [
		'toStep2',
		'toStep3',
		'stepOneContainer',
		'stepTwoContainer',
		'stepThreeContainer',
		'errorMessageFirstName',
		'errorMessageLastName',
		'errorMessageEmail',
		'errorMessageTerms',
		'selection',
		'amount',
		'price',
		'totalPrice',
		'BTW',
		'subtotal',
	];

	connect() {
		price = parseFloat(this.priceTarget.dataset.price.replace(',', '.'));
		btwAmount = parseFloat(this.BTWTarget.dataset.btw) / 100;
		this.calcPrices();
		this.insertPrices();
	}

	nextStepTwo() {
		const inputFirstName = document.querySelector('#firstname');
		const inputLastName = document.querySelector('#lastname');
		const inputEmail = document.querySelector('#email');
		const inputTerms = document.querySelector('#terms');
		const errorFirstName = this.errorMessageFirstNameTarget;
		const errorLastName = this.errorMessageLastNameTarget;
		const errorEmail = this.errorMessageEmailTarget;
		const errorTerms = this.errorMessageTermsTarget;

		let regName = new RegExp('([a-zA-Z]{2,30}s*)+');
		let regEmail = new RegExp('[a-z0-9]+@[a-z]+.[a-z]{2,3}');

		///////////////////////////// First name validation//////////////////////////
		if (inputFirstName.value === '') {
			errorFirstName.classList.remove('hidden');
			return;
		}
		if (!inputFirstName.value.toLowerCase().match(regName)) {
			errorFirstName.classList.remove('hidden');
			errorFirstName.innerText = 'Vul een geldige voornaam in';
			return;
		}
		////remove empty message if something is filled in
		if (inputFirstName.value != '' && !errorFirstName.classList.contains('hidden')) {
			errorFirstName.classList.add('hidden');
		}

		///////////////////////////// END First name validation////////////////////////

		///////////////////////////// Last name validation//////////////////////////
		if (inputLastName.value === '') {
			this.errorMessageLastNameTarget.classList.remove('hidden');
			return;
		}
		if (!inputLastName.value.toLowerCase().match(regName)) {
			errorLastName.classList.remove('hidden');
			errorLastName.innerText = 'Vul een geldige achternaam in';
			return;
		}
		////remove empty message if something is filled in
		if (inputLastName.value != '' && !errorLastName.classList.contains('hidden')) {
			errorLastName.classList.add('hidden');
		}
		///////////////////////////// END Last name validation////////////////////////

		///////////////////////////// Email validation//////////////////////////
		if (inputEmail.value === '') {
			errorEmail.classList.remove('hidden');
			return;
		}
		if (!inputEmail.value.toLowerCase().match(regEmail)) {
			errorEmail.classList.remove('hidden');
			errorEmail.innerText = 'Vul een geldig e-mailadres in';
			return;
		}
		////remove empty message if something is filled in
		if (inputEmail.value != '' && !errorEmail.classList.contains('hidden')) {
			errorEmail.classList.add('hidden');
		}
		///////////////////////////// END email validation//////////////////////////

		//if terms are not accepted show message and return
		if (inputTerms.checked != true) {
			errorTerms.classList.remove('hidden');
			return;
		}

		///Move to next step of form
		this.stepOneContainerTarget.classList.toggle('hidden');
		this.stepTwoContainerTarget.classList.toggle('hidden');
	}

	nextStepThree() {
		this.stepTwoContainerTarget.classList.toggle('hidden');
		this.stepThreeContainerTarget.classList.toggle('hidden');
	}

	prevStepOne() {
		this.stepOneContainerTarget.classList.toggle('hidden');
		this.stepTwoContainerTarget.classList.toggle('hidden');
	}

	prevStepTwo() {
		this.stepTwoContainerTarget.classList.toggle('hidden');
		this.stepThreeContainerTarget.classList.toggle('hidden');
	}

	calcPrices() {
		priceInclBTW = price * (btwAmount + 1);
		btwPrice = priceInclBTW - price;
	}

	insertPrices() {
		let amount = this.selectionTarget.value;
		let subtotal = price * amount;
		let btwTotal = btwPrice * amount;
		let total = priceInclBTW * amount;
		let thePrice = price * amount;
		this.amountTarget.innerText = amount;
		this.subtotalTarget.innerText = subtotal.toFixed(2).toString().replace('.', ',');
		this.BTWTarget.innerText = btwTotal.toFixed(2).toString().replace('.', ',');
		this.priceTarget.innerText = thePrice.toFixed(2).toString().replace('.', ',');
		this.totalPriceTarget.innerText = total.toFixed(2).toString().replace('.', ',');
	}
}
